import {Sidebar} from "../components/sidebar";
import {Outlet, useLocation} from "react-router-dom";
import {Footer} from "../components";
import {DesktopSize} from "../components/responsive";
import {useEffect} from "react";
import {SIDEBAR_ROUTES} from "../constants/routes";

export default function MainLayout() {

    const location = useLocation();

    useEffect(() => {
        let title = "پنل فریلنسر"
        try {
            for (let key in SIDEBAR_ROUTES) {
                if(SIDEBAR_ROUTES[key].url === location.pathname) {
                    title = SIDEBAR_ROUTES[key].title;
                    break;
                } else if (SIDEBAR_ROUTES[key].subMenu.length) {
                    for(let subKey in SIDEBAR_ROUTES[key].subMenu) {
                        if(SIDEBAR_ROUTES[key].subMenu[subKey].url === location.pathname) {
                            title = SIDEBAR_ROUTES[key].subMenu[subKey].title;
                            break;
                        }
                    }
                }
            }
            document.title = title;
        } catch (e) {
            document.title = title;
        }

    }, [location]);

    return (
        <div className="min-h-screen w-full bg-pol-light-purple flex flex-col xl:block">
            {/*min-h-screen w-full bg-pol-light-purple*/}

            {/*container flex gap-x-8 pt-[1.625rem] pb-5*/}
            <div className="container flex flex-grow xl:flex-grow-0 gap-x-8 pt-[1.625rem] pb-5">
                <DesktopSize>
                    <Sidebar/>
                </DesktopSize>
                <div className="flex-grow flex flex-col">
                    <Outlet/>
                    <div className="flex-1 flex items-end justify-end mt-auto xl:mt-8 m-padding-x">
                        <Footer/>
                    </div>
                </div>
            </div>
        </div>
    )
}
